<template>
  <div class="quoteCreate">
    <van-form label-width="120px">
      <div class="title" v-if="pageType == 'detail'">
        {{ $t.salesManagement.title3 }}
      </div>
      <div class="title" v-else>{{ $t.salesManagement.title4 }}</div>

      <van-field
        v-model="form.QuotationRefNumber"
        :label="$t.salesManagement.qrNumber"
        label-class="number-label"
        readonly
        v-if="form.QuotationRefNumber"
      >
        <template #button>
          <van-button size="small" type="info" @click="onCopy(form.QuotationRefNumber)">{{
            $t.meta.copy
          }}</van-button>
        </template>
      </van-field>

      <van-field
        v-model="form.QuotationNumber"
        :label="$t.salesManagement.qNumber"
        label-class="number-label"
        readonly
        v-if="form.QuotationNumber"
      >
        <template #button>
          <van-button size="small" type="info" @click="onCopy(form.QuotationNumber)">{{
            $t.meta.copy
          }}</van-button>
        </template>
      </van-field>

      <div class="custom-date">
        <div class="date-btn1">{{ $t.salesManagement.qValidity }}</div>
        <div class="date-btn2" @click="showTimeDate">
          <span v-if="form.QuoteValidity" class="value">{{ form.QuoteValidity }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <van-field
        v-model="form.QuotationDate"
        :label="$t.salesManagement.qDate"
        disabled
      />

      <div v-if="pageType !== 'unquote'">
        <van-field
          v-model="form.Customer.text"
          :label="$t.salesManagement.companyName"
          :placeholder="$t.meta.input"
          type="textarea"
          rows="3"
          @click="onShowEmit('showQuoteCreateCustomer')"
          clickable
          readonly
        />

        <van-field
          v-model="form.Customer.CustomerNumber"
          :label="$t.salesManagement.customerNumber"
          disabled
          v-if="form.Customer.CustomerNumber"
        />

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.meta.businessType }}</div>
          <van-radio-group v-model="form.BusinessType" direction="horizontal">
            <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
            <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
            <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
            <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
            <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
          </van-radio-group>
        </div>

        <van-field
          clickable
          readonly
          :value="form.Pol.text"
          :label="$t.salesManagement.deliveryPort"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showQuoteCreatePol')"
        />

        <van-field
          clickable
          readonly
          :value="form.Pod.text"
          :label="$t.salesManagement.destinationPort"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showQuoteCreatePod')"
        />

        <van-field
          v-model="form.TCName"
          :label="$t.salesManagement.tradeTerms"
          @click="pickerShow(0, 'showTCIdPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.salesManagement.brand }}</div>
          <van-radio-group v-model="form.Brand" direction="horizontal">
            <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio :name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </div>

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.salesManagement.liquid }}</div>
          <van-radio-group v-model="form.Liquid" direction="horizontal">
            <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio :name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </div>

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.salesManagement.powder }}</div>
          <van-radio-group v-model="form.Powder" direction="horizontal">
            <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio :name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </div>

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.salesManagement.magnetic }}</div>
          <van-radio-group v-model="form.Magnetic" direction="horizontal">
            <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio :name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </div>

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.salesManagement.exportType }}</div>
          <van-radio-group v-model="form.ExportType" direction="horizontal">
            <van-radio :name="1">{{ $t.salesManagement.export1 }}</van-radio>
            <van-radio :name="2">{{ $t.salesManagement.export2 }}</van-radio>
            <van-radio :name="3">{{ $t.salesManagement.export3 }}</van-radio>
          </van-radio-group>
        </div>

        <van-field
          v-model="form.NumberPackages.number"
          :label="$t.salesManagement.pNumber"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.NumberPackages.text"
          :label="$t.salesManagement.piecesUnit"
          @click="pickerShow(0, 'showNumberPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <van-field
          v-model="form.Volume.number"
          :label="$t.salesManagement.volume"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Volume.text"
          :label="$t.salesManagement.volumeUnit"
          @click="pickerShow(0, 'showVolumePicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <van-field
          v-model="form.Weight.number"
          :label="$t.salesManagement.weight"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Weight.text"
          :label="$t.salesManagement.weightUnit"
          @click="pickerShow(0, 'showWeightPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <van-field
          v-model="form.ECDName"
          :label="$t.salesManagement.commission"
          @click="pickerShow(0, 'showECDIdPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
        />

        <div class="quoteCreate-radio">
          <div class="radio-label">{{ $t.salesManagement.tdService }}</div>
          <van-radio-group
            v-model="form.TakeDeliveryService"
            direction="horizontal"
            @change="deliveryChange"
          >
            <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
            <van-radio :name="0">{{ $t.meta.no }}</van-radio>
          </van-radio-group>
        </div>

        <van-field
          clickable
          readonly
          :value="form.TakeDelivery.text"
          :label="$t.salesManagement.tdLocation"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showQuoteCreateCountry')"
          v-if="form.TakeDeliveryService == 1"
        />

        <van-field
          v-model="form.TakeDeliveryAddress"
          :label="$t.salesManagement.takeDeliveryAddress"
          :placeholder="$t.meta.input"
          type="textarea"
          v-if="form.TakeDeliveryService == 1"
        />
      </div>

      <div class="multi-table" v-if="form.polTable">
        <van-field name="stepper" :label="$t.salesManagement.polTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.polTable.length"
              @minus="handleDel('pol')"
              @plus="handleAdd('pol')"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.polTable" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex('pol', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'polTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'polTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="$t.meta.input"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.freightTable">
        <van-field name="stepper" :label="$t.salesManagement.freightTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.freightTable.length"
              @minus="handleDel('freight')"
              @plus="handleAdd('freight')"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.freightTable" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex('freight', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'freightTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'freightTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Carrier"
            :label="$t.salesManagement.carrier"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.TransitTime"
            :label="$t.salesManagement.transitTime"
            :placeholder="$t.meta.input"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.podTable">
        <van-field name="stepper" :label="$t.salesManagement.podTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.podTable.length"
              @minus="handleDel('pod')"
              @plus="handleAdd('pod')"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.podTable" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex('pod', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'podTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'podTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="$t.meta.input"
          />
        </div>
      </div>

      <div class="multi-table" v-if="form.seriveTable">
        <van-field name="stepper" :label="$t.salesManagement.serviceTitle">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.seriveTable.length"
              @minus="handleDel('service')"
              @plus="handleAdd('service')"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.seriveTable" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex('service', index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.meta.chagreTitle"
            @click="pickerShow(index, 'showItemPicker', 'seriveTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker', 'seriveTable')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.Pricing"
            :label="$t.salesManagement.pricing"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.Unit"
            :label="$t.salesManagement.unit"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.Total"
            :label="$t.salesManagement.total"
            :placeholder="$t.meta.input"
          />
        </div>
      </div>

      <van-field
        v-model="form.Remark"
        :label="$t.salesManagement.remark"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="5"
      />

      <div style="margin: 16px" v-if="pageType == 'detail'">
        <van-button round block type="info" @click="onEdit">{{
          $t.meta.save
        }}</van-button>
      </div>
      <div style="margin: 16px" v-else>
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <fetch-list
      event="showQuoteCreateCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <option-list
      event="showQuoteCreatePol"
      :options="countryList"
      @onSelect="onSelectPol"
    ></option-list>

    <option-list
      event="showQuoteCreatePod"
      :options="countryList"
      @onSelect="onSelectPod"
    ></option-list>

    <option-list
      event="showQuoteCreateCountry"
      :options="deliveryCountryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <van-popup v-model="showTCIdPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.tradeTerms"
        show-toolbar
        :columns="tcList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="tcidConfirm"
        @cancel="showTCIdPicker = false"
      />
    </van-popup>

    <van-popup v-model="showNumberPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.piecesUnit"
        show-toolbar
        :columns="packageList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="numberConfirm"
        @cancel="showNumberPicker = false"
      />
    </van-popup>

    <van-popup v-model="showVolumePicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.volumeUnit"
        show-toolbar
        :columns="volumeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="volumeConfirm"
        @cancel="showVolumePicker = false"
      />
    </van-popup>

    <van-popup v-model="showWeightPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.weightUnit"
        show-toolbar
        :columns="weightList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="weightConfirm"
        @cancel="showWeightPicker = false"
      />
    </van-popup>

    <van-popup v-model="showECDIdPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.commission"
        show-toolbar
        :columns="ecdList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="ecdConfirm"
        @cancel="showECDIdPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.salesManagement.qValidity"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showItemPicker" round position="bottom">
      <van-picker
        :title="$t.meta.chagreTitle"
        show-toolbar
        :columns="billList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'BillName', 'BillId')"
        @cancel="showItemPicker = false"
      />
    </van-popup>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'CurrencySn', 'Currency')"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <div class="tool-bar" v-if="pageType == 'detail'">
      <van-button type="info" block @click="gotoPrint">{{ $t.meta.print }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "quoteCreate",
  components: {
    FetchList,
    OptionList,
  },
  data() {
    return {
      pageType: "new",
      content: {},
      form: {
        //1
        QRId: 0, //报价参考号
        QuotationNumber: "", //报价单号
        QuotationRefNumber: "", //询价参考号（详情页）
        Customer: { value: "" },
        QuotationDate: "", //报价单日期
        QuoteValidity: "", //报价有效期
        Pol: {},
        Pod: {},
        GoodsName: "",
        //2
        NumberPackages: {
          number: null,
          text: "",
          value: "1",
        },
        Volume: {
          number: null,
          text: "",
          value: "1",
        },
        Weight: {
          number: null,
          text: "",
          value: "1",
        },
        BusinessType: 1,
        //贸易条款
        TCName: "",
        TCId: "",
        //委托报关
        ECDName: "",
        ECDId: "1",
        //3
        Brand: 0,
        Liquid: 0,
        Powder: 0,
        Magnetic: 0,
        ExportType: 2,
        TakeDeliveryService: 0,
        TakeDelivery: {}, //CountryId,Id
        TakeDeliveryAddress: "",
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        polTable: [],
        freightTable: [],
        podTable: [],
        seriveTable: [],
        Remark: "",
        //4
        IsEdit: false,
      },
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
      //国家城市选项
      countryList: [],
      currencyList: [],
      deliveryCountryList: [],
      //货运选项
      settings: [],
      tcList: [],
      ecdList: [],
      packageList: [],
      volumeList: [],
      weightList: [],
      billList: [],
      //picker
      itemIndex: 0,
      itemTable: "polTable",
      showTCIdPicker: false,
      showNumberPicker: false,
      showVolumePicker: false,
      showWeightPicker: false,
      showECDIdPicker: false,
      showItemPicker: false,
      showCurrencyPicker: false,
    };
  },
  created() {
    const { Type, QRId, QuotationRefNumber } = this.$route.query;
    this.getCurrencyList();
    this.getOptions().then((success) => {
      if (success) {
        if (Type == "new") {
          this.pageType = "new";
          //新增页
          this.loadQuotationInfo(null).then((success) => {
            if (success) {
              this.form.QuotationRefNumber = this.content.QuotationRefNumber;
              this.form.QuotationDate = this.content.QuotationDate;
              this.getCountrys(1);
            }
          });
        }
        if (Type == "detail") {
          this.pageType = "detail";
          //详情页
          this.form.QRId = QRId; //报价单号
          this.loadQuotationInfo(this.form.QRId).then((success) => {
            if (success) {
              this.form.QuotationNumber = this.content.QuotationNumber;
              this.form.QuotationDate = this.content.QuotationDate;
              this.applyData(this.content);
            }
          });
        }
        if (Type == "unquote") {
          this.pageType = "unquote";
          //待报价新增页
          this.form.QRId = QRId; //报价单号
          this.form.QuotationRefNumber = QuotationRefNumber; //询价参考号
          this.loadQuotationInfo(this.form.QRId).then((success) => {
            if (success) {
              this.form.QuotationDate = this.content.QuotationDate;
              this.getCountrys(1);
            }
          });
        }
      }
    });
  },
  methods: {
    handleAdd(type) {
      if (type == "pol") {
        this.form.polTable.push({
          ChargeType: 1,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          CurrencySn: "",
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
      if (type == "freight") {
        this.form.freightTable.push({
          ChargeType: 2,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
          Carrier: "", //航空公司
          TransitTime: "", //运输时长
        });
      }
      if (type == "pod") {
        this.form.podTable.push({
          ChargeType: 3,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
      if (type == "service") {
        this.form.seriveTable.push({
          ChargeType: 4,
          BillName: "",
          BillId: "", //收款项目
          Currency: null, //货币
          Pricing: null, //定价
          Unit: "", //单位
          Total: null, //总计
        });
      }
    },
    handleDel(type) {
      if (type == "pol" && this.form.polTable.length > 0) {
        this.form.polTable.pop();
      }
      if (type == "freight" && this.form.freightTable.length > 0) {
        this.form.freightTable.pop();
      }
      if (type == "pod" && this.form.podTable.length > 0) {
        this.form.podTable.pop();
      }
      if (type == "service" && this.form.seriveTable.length > 0) {
        this.form.seriveTable.pop();
      }
    },
    handleDelByIndex(type, index) {
      if (type == "pol" && this.form.polTable.length > 0) {
        this.form.polTable.splice(index, 1);
      }
      if (type == "freight" && this.form.freightTable.length > 0) {
        this.form.freightTable.splice(index, 1);
      }
      if (type == "pod" && this.form.podTable.length > 0) {
        this.form.podTable.splice(index, 1);
      }
      if (type == "service" && this.form.seriveTable.length > 0) {
        this.form.seriveTable.splice(index, 1);
      }
    },
    showTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.form.QuoteValidity = formatDate(date);
      this.showTimePicker = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    loadQuotationInfo(qrid) {
      return new Promise((resolve) => {
        let param = { QRId: qrid ? qrid : 0, CompanyId: this.form.CompanyId };
        this.$api.salesManagement
          .loadQuotationInfo(param)
          .then((res) => {
            this.content = res.data;
            //是否能编辑
            this.form.IsEdit = this.content.QuotationReferenceInfo.IsEdit;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getBillPaymentList(), this.getEntrustOrderSetting()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getBillPaymentList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getBillPaymentListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.BillId,
              };
              result.push(data);
            });
            this.billList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getEntrustOrderSetting() {
      return new Promise((resolve) => {
        this.$api.salesManagement
          .getEntrustOrderSetting()
          .then((res) => {
            this.settings = res.data;

            var tcList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.TCName,
                value: item.TCId,
              };
              tcList.push(data);
            });
            this.tcList = this.$commonMethod.deepClone(tcList);

            var ecdList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.ECDName,
                value: item.ECDId,
              };
              ecdList.push(data);
            });
            this.ecdList = this.$commonMethod.deepClone(ecdList);

            var packageList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.NPUId,
              };
              packageList.push(data);
            });
            this.packageList = this.$commonMethod.deepClone(packageList);

            var volumeList = [];
            this.settings[4].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.VUId,
              };
              volumeList.push(data);
            });
            this.volumeList = this.$commonMethod.deepClone(volumeList);

            var weightList = [];
            this.settings[5].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.WUId,
              };
              weightList.push(data);
            });
            this.weightList = this.$commonMethod.deepClone(weightList);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    deliveryChange() {
      this.form.TakeDelivery = {};
      this.getDeliveryCountrys();
    },
    pickerShow(index, pickerName, table) {
      this[pickerName] = true;
      this.itemIndex = index;
      if (table) this.itemTable = table;
    },
    tcidConfirm(e) {
      this.form.TCName = e.text;
      this.form.TCId = e.value;
      this.showTCIdPicker = false;
    },
    numberConfirm(e) {
      this.form.NumberPackages.text = e.text;
      this.form.NumberPackages.value = e.value;
      this.showNumberPicker = false;
    },
    volumeConfirm(e) {
      this.form.Volume.text = e.text;
      this.form.Volume.value = e.value;
      this.showVolumePicker = false;
    },
    weightConfirm(e) {
      this.form.Weight.text = e.text;
      this.form.Weight.value = e.value;
      this.showWeightPicker = false;
    },
    ecdConfirm(e) {
      this.form.ECDName = e.text;
      this.form.ECDId = e.value;
      this.showECDIdPicker = false;
    },
    onSelectCustomer(e) {
      this.form.Customer.text = e.text;
      this.form.Customer.value = e.value;
      this.form.Customer.CustomerNumber = e.CustomerNumber;
      this.$forceUpdate();
    },
    onSelectPol(e) {
      this.form.Pol.text = e.text;
      this.form.Pol.value = e.value;
      this.form.Pol.CountryId = e.CountryId;
      this.$forceUpdate();
    },
    onSelectPod(e) {
      this.form.Pod.text = e.text;
      this.form.Pod.value = e.value;
      this.form.Pod.CountryId = e.CountryId;
      this.$forceUpdate();
    },
    onSelectCountry(e) {
      this.form.TakeDelivery.text = e.text;
      this.form.TakeDelivery.value = e.value;
      this.form.TakeDelivery.CountryId = e.CountryId;
      this.$forceUpdate();
    },
    pickerConfirm(e, text, value) {
      this.form[this.itemTable][this.itemIndex][text] = e.text;
      this.form[this.itemTable][this.itemIndex][value] = e.value;
      this.showItemPicker = false;
      this.showCurrencyPicker = false;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      var param = {
        QRId: this.form.QRId,
        IsEdit: this.form.IsEdit,
        QuotationNumber: this.form.QuotationNumber,
        AddUserId: this.form.UserId,
        ValidityTime: this.form.QuoteValidity,
        Remark: this.form.Remark,
        QuotationReference: null,
        QuotationChargesItemList: this.form.polTable.concat(
          this.form.freightTable,
          this.form.podTable,
          this.form.seriveTable
        ),
      };
      if (this.pageType !== "unquote") {
        param.QuotationReference = this.getReference();
      }
      this.$commonMethod.showLoading();
      this.$api.salesManagement
        .addQuotationCharges(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onEdit() {
      var param = {
        QCId: this.content.QCId,
        IsEdit: this.form.IsEdit,
        ValidityTime: this.form.QuoteValidity,
        Remark: this.form.Remark,
        QuotationChargesItemList: this.form.polTable.concat(
          this.form.freightTable,
          this.form.podTable,
          this.form.seriveTable
        ),
        QRId: this.content.QuotationReferenceInfo.QRId,
        QuotationReference: this.getReference(),
      };
      this.$commonMethod.showLoading();
      this.$api.salesManagement
        .editQuotationCharges(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.loadQuotationInfo(this.form.QRId).then((success) => {
            if (success) {
              this.applyData(this.content);
            }
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getReference() {
      return {
        QRId: this.content.QuotationReferenceInfo.QRId,
        CustomerId: this.form.Customer.value,
        BusinessType: this.form.BusinessType,
        DeliveryCountryId: this.form.Pol.CountryId,
        DeliveryCityId: this.form.Pol.value,
        DestinationCountryId: this.form.Pod.CountryId,
        DestinationCityId: this.form.Pod.value,
        GoodsName: this.form.GoodsName,
        TCId: parseInt(this.form.TCId),
        NumberPackages: parseInt(this.form.NumberPackages.number),
        NPUId: parseInt(this.form.NumberPackages.value),
        Volume: parseFloat(this.form.Volume.number),
        VUId: parseInt(this.form.Volume.value),
        Weight: parseFloat(this.form.Weight.number),
        WUId: parseInt(this.form.Weight.value),
        Brand: this.form.Brand,
        Liquid: this.form.Liquid,
        Powder: this.form.Powder,
        Magnetic: this.form.Magnetic,
        ExportType: this.form.ExportType,
        TakeDeliveryService: this.form.TakeDeliveryService,
        TakeDeliveryCountry: this.form.TakeDelivery.CountryId,
        TakeDeliveryCity: this.form.TakeDelivery.value,
        TakeDeliveryAddress: this.form.TakeDeliveryAddress,
        ECDId: parseInt(this.form.ECDId),
      };
    },
    applyData(data) {
      this.form.QuoteValidity = data.ValidityTime;
      this.form.Remark = data.Remark;
      this.form.QuotationRefNumber = data.QuotationReferenceInfo.QuotationRefNumber;
      this.form.Customer = {
        text: data.QuotationReferenceInfo.CompanyName,
        value: data.QuotationReferenceInfo.CustomerId,
        CustomerNumber: data.QuotationReferenceInfo.CustomerNumber,
      };
      //业务类型
      this.form.BusinessType = data.QuotationReferenceInfo.BusinessType;
      this.getCountrys(this.form.BusinessType);
      this.form.Pol = {
        //起运港
        text: data.QuotationReferenceInfo.DeliveryCityName,
        value: data.QuotationReferenceInfo.DeliveryCityId,
        CountryId: data.QuotationReferenceInfo.DeliveryCountryId,
      };
      this.form.Pod = {
        //目的港
        text: data.QuotationReferenceInfo.DestinationCityName,
        value: data.QuotationReferenceInfo.DestinationCityId,
        CountryId: data.QuotationReferenceInfo.DestinationCountryId,
      };
      //贸易条款
      this.form.TCId = data.QuotationReferenceInfo.TCId.toString();
      this.form.TCName = data.QuotationReferenceInfo.TCName.toString();
      //委托报关
      this.form.ECDId = data.QuotationReferenceInfo.ECDId.toString();
      this.form.ECDName = data.QuotationReferenceInfo.ECDName;
      //提货服务
      this.form.TakeDeliveryService = parseInt(
        data.QuotationReferenceInfo.TakeDeliveryService
      );
      if (this.form.TakeDeliveryService) {
        this.getDeliveryCountrys().then((success) => {
          if (success) {
            this.form.TakeDelivery = {
              //提货地点
              text: data.QuotationReferenceInfo.TakeDeliveryCityName,
              value: data.QuotationReferenceInfo.TakeDeliveryCity,
              CountryId: data.QuotationReferenceInfo.TakeDeliveryCountry,
            };
          }
        });
      }
      this.form.NumberPackages = {
        //件数
        text: data.QuotationReferenceInfo.NumberPackagesUnitName,
        number: data.QuotationReferenceInfo.NumberPackages,
        value: data.QuotationReferenceInfo.NPUId.toString(),
      };
      this.form.Volume = {
        //体积
        text: data.QuotationReferenceInfo.VolumeUnitName,
        number: data.QuotationReferenceInfo.Volume,
        value: data.QuotationReferenceInfo.VUId.toString(),
      };
      this.form.Weight = {
        //重量
        text: data.QuotationReferenceInfo.WeightUnitName,
        number: data.QuotationReferenceInfo.Weight,
        value: data.QuotationReferenceInfo.WUId.toString(),
      };
      this.form.GoodsName = data.QuotationReferenceInfo.GoodsName;
      this.form.polTable = data.QuotationChargesItemList1;
      for (const polItem of this.form.polTable) {
        var bill = this.billList.find((c) => c.value == polItem.BillId);
        if (bill) {
          polItem.BillName = bill.text;
        }
        var currency = this.currencyList.find((c) => c.value == polItem.Currency);
        if (currency) {
          polItem.CurrencySn = currency.text;
        }
      }
      this.form.freightTable = data.QuotationChargesItemList2;
      for (const freightItem of this.form.freightTable) {
        var bill = this.billList.find((c) => c.value == freightItem.BillId);
        if (bill) {
          freightItem.BillName = bill.text;
        }
        var currency = this.currencyList.find((c) => c.value == freightItem.Currency);
        if (currency) {
          freightItem.CurrencySn = currency.text;
        }
      }
      this.form.podTable = data.QuotationChargesItemList3;
      for (const podItem of this.form.podTable) {
        var bill = this.billList.find((c) => c.value == podItem.BillId);
        if (bill) {
          podItem.BillName = bill.text;
        }
        var currency = this.currencyList.find((c) => c.value == podItem.Currency);
        if (currency) {
          podItem.CurrencySn = currency.text;
        }
      }
      this.form.seriveTable = data.QuotationChargesItemList4;
      for (const seriveItem of this.form.seriveTable) {
        var bill = this.billList.find((c) => c.value == seriveItem.BillId);
        if (bill) {
          seriveItem.BillName = bill.text;
        }
        var currency = this.currencyList.find((c) => c.value == seriveItem.Currency);
        if (currency) {
          seriveItem.CurrencySn = currency.text;
        }
      }
      this.form.Brand = parseInt(data.QuotationReferenceInfo.Brand);
      this.form.Liquid = parseInt(data.QuotationReferenceInfo.Liquid);
      this.form.Powder = parseInt(data.QuotationReferenceInfo.Powder);
      this.form.Magnetic = parseInt(data.QuotationReferenceInfo.Magnetic);
      if (parseInt(data.QuotationReferenceInfo.AgentExport)) {
        this.form.ExportType = 1;
      } else if (parseInt(data.QuotationReferenceInfo.ExportRebates)) {
        this.form.ExportType = 2;
      } else if (parseInt(data.QuotationReferenceInfo.Import)) {
        this.form.ExportType = 3;
      } else {
        this.form.ExportType = 2;
      }
      this.form.TakeDeliveryAddress = data.QuotationReferenceInfo.TakeDeliveryAddress;
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getDeliveryCountrys() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({ type: 1 })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
                CountryId: item.CountryId,
              };
              result.push(data);
            });
            this.deliveryCountryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCountrys(type) {
      return new Promise((resolve) => {
        let param = {};
        if (type == 2 || type == 4) {
          param.type = 2;
        } else {
          param.type = 1;
        }
        this.$api.logisticsManagement
          .getCountryList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text:
                  item.CountryName +
                  " , " +
                  item.CountryName_en +
                  " , " +
                  item.City_cn +
                  " , " +
                  item.City_en,
                value: item.Id,
                CountryId: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    gotoPrint() {
      var param = {
        QRId: this.form.QRId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createQuotationInfoPdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.quoteCreate {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }

  .quoteCreate-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  .quoteCreate-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }

  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;

    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }

    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;

      .value {
        color: #323233;
      }

      .placeholder {
        color: #c3c3c3;
      }
    }
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;

      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
